__turbopack_context__.v({
  "badgeContainer": "IconCategoryCard-module-scss-module__aVgiGW__badgeContainer",
  "iconWrapper": "IconCategoryCard-module-scss-module__aVgiGW__iconWrapper",
  "newBadge": "IconCategoryCard-module-scss-module__aVgiGW__newBadge",
  "root": "IconCategoryCard-module-scss-module__aVgiGW__root",
  "textWeightHeavy": "IconCategoryCard-module-scss-module__aVgiGW__textWeightHeavy",
  "title": "IconCategoryCard-module-scss-module__aVgiGW__title",
});
